import React from "react"
import { Link } from "react-router-dom";
import InfoPage from "./InfoPage"
import AppSettings from "../../../AppSettings"

export default function AccountingForms() {
    const Download = ({ file, title, children }) => <>
        <h2><a href={AppSettings.AccountingForms + file} target="_blank" rel="noopener noreferrer">
            <img src="/images/info/PDF.png" alt="" />{title}</a>
        </h2>
        {children}
    </>

    return <InfoPage className="acctforms">
        <h1>Accounting Forms</h1>
        <p>
            Did you know that <Link to="/about">Case Parts is older than the internet</Link>?
        </p><p>
            Alas, we still use a few paper forms.  Our website and online tools have come a very long way over the past few years and we are working on replacing all these forms with modern alternatives. In the meantime, thanks for bearing with us just a little longer.
        </p><p>
            Please click the links below to download forms.  Then print and have the appropriate person sign before sending it back to us.
        </p>
        <div className="contactMethods">
            <div className="label">Email:</div>
            <div className="value"><a href="mailto:accounting@caseparts.com">accounting@caseparts.com</a></div>
            <div className="label">Fax:</div>
            <div className="value">(323) 263-1210</div>
            <div className="label">Postal:</div>
            <div className="value">877 Monterey Pass Road<br />Monterey Park, CA 91754</div>
        </div>
        <Download file="tradeapplication.pdf" title="Account Application">
            <p>A Case Parts account provides many advantages including:</p>
            <ul>
                <li>Order &amp; Invoice history</li>
                <li>Multi-user support with customized user permissions (ex., technicians may place orders, but not access invoices)</li>
                <li>On account payment terms</li>
                <li>Discounted pricing for resellers</li>
            </ul>
        </Download>
        <Download file="BillRecipient.pdf" title="Bill Recipient Authorization">
            <p>
                Case Parts has shipped millions of packages via UPS and gets very good shipping rates that we pass on to you. Nonetheless, if you prefer, we can use your UPS account when shipping your orders.
            </p>
        </Download>
    </InfoPage>
}